import React from 'react';
import { Paper, Box, Button, TextField, Typography } from '@material-ui/core';
import { Form, Field } from 'react-final-form';
import { uploadTypes } from '../../../../config/constants';
import ImageUploadField from '../ImageUploadField';

const SplashScreenTab = ({ config, onSave }) => {
  const handleSubmit = (values) => {
    onSave({
      ...config,
      splash_background: values.splash_background,
      splash_overlay_image: values.splash_overlay_image,
      splash_cta_color: values.splash_cta_color,
    });
  };

  const initialValues = {
    splash_background: config?.splash_background,
    splash_overlay_image: config?.splash_overlay_image,
    splash_cta_color: config?.splash_cta_color,
  };

  return (
    <Paper>
      <Box p={3}>
        <Typography variant="h6" gutterBottom>
          Splash Screen Settings
        </Typography>
        <Form
          onSubmit={handleSubmit}
          initialValues={initialValues}
          render={({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit}>
              <Box display="flex" flexDirection="column" gap={2}>
                <ImageUploadField
                  name="splash_background"
                  label="Background Image"
                  uploadType={uploadTypes.wordFinder}
                  helperText="Minimum 375Wx825H"
                />

                <ImageUploadField
                  name="splash_overlay_image"
                  label="Overlay Image (floating element)"
                  uploadType={uploadTypes.wordFinder}
                  helperText="Max 200 px wide - the app allows filling up to 70% of the screen width, the height adjusts accordingly"
                />

                <Field name="splash_cta_color">
                  {({ input }) => (
                    <Box mt={2}>
                      <TextField
                        label="Kezdes CTA Button Color"
                        value={input.value}
                        onChange={input.onChange}
                        placeholder="#db0a40"
                        helperText="HEX color code (e.g., #db0a40)"
                        fullWidth
                      />
                      <Box mt={1} display="flex" alignItems="center" gap={1}>
                        <Box width={40} height={40} bgcolor={input.value} borderRadius={4} border="1px solid #ccc" />
                        <input
                          type="color"
                          value={input.value}
                          onChange={(e) => input.onChange(e.target.value)}
                          style={{ cursor: 'pointer' }}
                        />
                      </Box>
                    </Box>
                  )}
                </Field>

                <Box mt={3}>
                  <Button type="submit" variant="contained" color="primary" disabled={submitting}>
                    Save Splash Screen Settings
                  </Button>
                </Box>
              </Box>
            </form>
          )}
        />
      </Box>
    </Paper>
  );
};

export default SplashScreenTab;
